import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AppTokenHandler } from '../../common/app-token-handler';
import { DataService } from '../../common/data.service';
import { AlertService } from '../../common/alert.service';
import { IAuditTrail, IBPAddress, IBPRecord, IGSTINType, Roles } from '../../model/bp-record';
import { ProgressService } from '../../common/progress.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-eccid-details',
  templateUrl: './eccid-details.component.html',
  styleUrls: ['./eccid-details.component.css']
})
export class ECCIDDetailsComponent implements OnInit {
  auditCols: any[];
  paramid: any;
  bpaddress: IBPAddress;
  auditloading: boolean = false;
  showUnregistered: boolean = false;
  showLoa: boolean = false;
  confirmtype: string = "";
  showComment: boolean = false;
  showGSTNReasonError: boolean = false;
  showLoaValidationError: boolean = false;
  showLoaDateToError: boolean = false;
  showLoaDateFromError: boolean = false;
  showTanReasonError: boolean = false;
  showPanAttachError: boolean = false;
  showGSTNAttachError: boolean = false;
  showDecAttachError: boolean = false;
  showLoaAttachError: boolean = false;
  showGSTTypeError: boolean = false;
  showGstnNoError: boolean = false;

  showTax1IdError: boolean = false;
  showTax1CountryError: boolean = false;
  showTax4IdError: boolean = false;
  showTax4CountryError: boolean = false;
  showTax3CountryError: boolean = false;
  showVatError: boolean = false;
  showVatCountryError: boolean = false;
  showNationalIdError: boolean = false;
  showNationalIdCountryError: boolean = false;


  displayAuditTrail: boolean = false;
  auditTrailList: Array<IAuditTrail> = [];
  first: number = 0;
  roles = Roles;
  bprecord: IBPRecord;
  gstFile: any;
  panFile: any;
  loaFile: any;
  declarationFile: any;

  paramAll: string | null;
  paramIsClient: string | null;
  paramIsDpc: string | null;

  constructor(private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private eccRecordService: DataService,
    private messageService: MessageService,
    private route: Router,
    private appToken: AppTokenHandler,
    private alertService: AlertService,
    private progressService: ProgressService) { }

  eccRecordForm: FormGroup = this.fb.group({
    MdmId: [''],
    BPName: [''],
    EccId: [''],
    AddressLine1: [''],
    AddressLine2: [''],
    AddressLine3: [''],
    AddressLine4: [''],
    AddressLine5: [''],
    City: [''],
    PostalCode: [''],
    StateProvinceRef: [''],
    StateProvinceName: [''],
    EmailAddress: [''],
    PhoneNumber: [''],
    RegionName: [''],
    AreaName: [''],
    EntityType: [''],
    RequestorName: [''],
    VatId: [''],
    VatIdCountry: [''],
    Tax1Id: [''],
    Tax1Country: [''],
    Tax2Id: [''],
    Tax2Country: [''],
    PANAttachmentName: [''],
    Tax3Id: [''],
    Tax3Country: [''],
    GSTAttachmentName: [''],
    LoaAttachmentName: [''],
    DeclarationAttachmentName: [''],
    ReasonNonAvailabilityGSTIN: [''],
    ReasonNonAvailabilityTAN: [''],
    LoaValidityFrom: [''],
    LoaValidityTo: [''],
    GSTINTypeName: [''],
    GSTINType: [''],
    Tax4Id: [''],
    Tax4Country: [''],
    Tax5Id: [''],
    Tax5Country: [''],
    NationalId: [''],
    NationalIdCountry: [''],
    Comments: [''],
    BPClassification: [''],
    BPCountry: [''],
  });

  gstnypeList: Array<IGSTINType> = [
    {
      Id: 0,
      Name: '-- select --',
    },
    {
      Id: 1,
      Name: 'DT – Regular',
    },
    {
      Id: 2,
      Name: 'UI – United Nation Body',
    },
    {
      Id: 3,
      Name: 'IS – Input Service Distributor',
    },
    {
      Id: 4,
      Name: 'S1 – SEZ Unit / Developer',
    },
    // {
    //   Id: 5,
    //   Name: 'S1 – SEZ Developer',
    // },
    {
      Id: 6,
      Name: 'UN – unregistered',
    },
  ];

  ngOnInit() {
    this.paramAll = this.activatedRoute.snapshot.queryParamMap.get('isall');
    this.paramIsClient = this.activatedRoute.snapshot.queryParamMap.get('isclient');
    this.paramIsDpc = this.activatedRoute.snapshot.queryParamMap.get('isdpc');

    this.auditCols = [
      { field: 'Name', header: 'Name', hidden: false },
      { field: 'CreatedOn', header: 'Updated On', hidden: false, width: '100px' },
      { field: 'FieldName', header: 'Field Name', hidden: false, width: '150px' },
      { field: 'OldValue', header: 'Old Value', hidden: false, width: '150px' },
      { field: 'NewValue', header: 'New Value', hidden: false, width: '100px' },
      { field: 'Action', header: 'Action', hidden: false, width: '200px' },
    ];

    this.paramid = this.activatedRoute.snapshot.queryParamMap.get('id');
    this.paramid = this.eccRecordService.DecryptData(this.paramid);

    this.eccRecordService.GetData('GetBPAddressDetails/' + this.paramid.toString().trim() + '/' + this.paramIsClient).subscribe(
      (data: any) => {
        this.bpaddress = data;
        this.progressService.ChangeProgressStatus(false);
        this._initForm();
      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'error', _error.statusText);
      }
    );
  }

  private _initForm(): void {
    this.eccRecordForm.patchValue({
      MdmId: this.bpaddress.MdmId,
      BPName: this.bpaddress.BPName,
      EccId: this.bpaddress.EccId,
      AddressLine1: this.bpaddress.AddressLine1,
      AddressLine2: this.bpaddress.AddressLine2,
      AddressLine3: this.bpaddress.AddressLine3,
      AddressLine4: this.bpaddress.AddressLine4,
      AddressLine5: this.bpaddress.AddressLine5,
      City: this.bpaddress.City,
      PostalCode: this.bpaddress.PostalCode,
      StateProvinceRef: this.bpaddress.StateProvinceRef,
      StateProvinceName: this.bpaddress.StateProvinceName,
      EmailAddress: this.bpaddress.EmailAddress,
      PhoneNumber: this.bpaddress.PhoneNumber,
      RegionName: this.bpaddress.RegionName,
      AreaName: this.bpaddress.AreaName,
      EntityType: this.bpaddress.EntityType,
      RequestorName: this.bpaddress.RequestorName,
      VatId: this.bpaddress.VatId,
      VatIdCountry: this.bpaddress.VatIdCountry,
      Tax1Id: this.bpaddress.Tax1Id,
      Tax1Country: this.bpaddress.Tax1Country,
      Tax2Id: this.bpaddress.Tax2Id,
      Tax2Country: this.bpaddress.Tax2Country,
      PANAttachmentName: this.bpaddress.PANAttachmentName,
      LoaAttachmentName: this.bpaddress.LoaAttachmentName,
      LoaValidityFrom: this.bpaddress.LoaValidityFrom ? new Date(this.bpaddress.LoaValidityFrom) : null,
      LoaValidityTo: this.bpaddress.LoaValidityTo ? new Date(this.bpaddress.LoaValidityTo) : null,
      Tax3Id: this.bpaddress.Tax3Id,
      Tax3Country: this.bpaddress.Tax3Country,
      GSTAttachmentName: this.bpaddress.GSTAttachmentName,
      DeclarationAttachmentName: this.bpaddress.DeclarationAttachmentName,
      ReasonNonAvailabilityGSTIN: this.bpaddress.ReasonNonAvailabilityGSTIN,
      ReasonNonAvailabilityTAN: this.bpaddress.ReasonNonAvailabilityTAN,
      GSTINTypeName: this.bpaddress.GSTINTypeName,
      GSTINType: this.gstnypeList.find(gs => gs.Id === this.bpaddress.GSTINTypeId),
      Tax4Id: this.bpaddress.Tax4Id,
      Tax4Country: this.bpaddress.Tax4Country,
      Tax5Id: this.bpaddress.Tax5Id,
      Tax5Country: this.bpaddress.Tax5Country,
      NationalId: this.bpaddress.NationalId,
      NationalIdCountry: this.bpaddress.NationalIdCountry,
      BPCountry: this.bpaddress.BPCountry,
      BPClassification: this.bpaddress.BPClassification,
      Comments: this.bpaddress.Comments
    });

    if (this.bpaddress.GSTINTypeId === 4 || this.bpaddress.GSTINTypeId === 5) {
      this.showLoa = true;
    }
    if (this.bpaddress.GSTINTypeId === 6) {
      this.showUnregistered = true;
    }
  }

  onShowAuditTrail() {
    this.auditloading = true;
    this.displayAuditTrail = true;
    this.eccRecordService.GetData('GetAllAuditTrailByID/' + this.paramid.toString().trim() + '/bpaddressBO').subscribe(
      (data: any) => {
        this.progressService.ChangeProgressStatus(false);
        this.auditTrailList = data;
        this.displayAuditTrail = true;
        this.auditloading = false;
      });
    this.auditloading = false;
  };

  paginate(event) {
    this.first = event.first;
  }


  onExit(_confirmtype: string) {
    let mdmid = this.eccRecordService.EncryptData(this.bpaddress.MdmId);
    if (this.paramAll) {
      if (this.paramIsClient) {
        this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isclient: true } });
      } else if (this.paramIsDpc) {
        this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isdpc: true } });
      } else {
        this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true } });
      }
    }
    else if (this.paramIsClient) {
      this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isclient: true } });
    } else if (this.paramIsDpc) {
      this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isdpc: true } });
    }
  }


  /* TEMP
  isDisabled() {
    let isDisabled = true;
    if (this.userHasRole(this.roles.ProspectSubmitter) && this.bpaddress && this.bpaddress.EccStatus === 1 && this.paramIsClient && this.bpaddress.ProspectSubmitterGPN == this.appToken.getLoginUserInfo().EmpGPN) {
      isDisabled = false;
    }

    return isDisabled;

  }
  */

  userHasRole(roleId: number) {
    let visible: boolean = false;
    if (this.appToken.IsInRole(Roles[roleId])) {
      visible = true;
    }
    return visible;
  }

  getStatus() {
    let status: string = '';
    switch (this.bpaddress && this.bpaddress.EccStatus) {
      case 1: status = 'Pending with Client server'
        break;
      case 2: status = 'Pending with DPC for review'
        break;
      case 3: status = 'Reviewed'
        break;
    }

    return status;
  }

  downloadPanFile() {
    this.eccRecordService.GetFileDataById('DownloadBPAddressPanFileBlob', this.paramid).subscribe(
      (data: any) => {
        this.progressService.ChangeProgressStatus(false);
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadGstFile() {
    this.eccRecordService.GetFileDataById('DownloadBPAddressGstFileBlob', this.paramid).subscribe(
      (data: any) => {
        this.progressService.ChangeProgressStatus(false);
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadLoaFile() {
    this.eccRecordService.GetFileDataById('DownloadBPAddressLoaAttachmentFileBlob', this.paramid).subscribe(
      (data: any) => {
        this.progressService.ChangeProgressStatus(false);
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadLDeclarationFile() {
    this.eccRecordService.GetFileDataById('DownloadBPAddressDeclarationFileBlob', this.paramid).subscribe(
      (data: any) => {
        this.progressService.ChangeProgressStatus(false);
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  showConfirm(_confirmtype: string) {
    this.confirmtype = _confirmtype;
    let confirmMessage: string = "";

    if (this.confirmtype == "return") {

      confirmMessage = "Are you sure you want to return?";
    }

    this.messageService.clear();
    this.messageService.add({ key: 'c', sticky: true, severity: 'warn', summary: confirmMessage, detail: '' });

  }

  onConfirm(confirmtype: string) {
    this.messageService.clear('c');
    if (this.confirmtype == "return") {
      this.returnRecord();
    }
  }

  onReject() {
    this.messageService.clear('c');
  }

  fileInputChange(event) {
    for (var i = 0; i < event.target.files.length; i++) {
      var f = event.target.files[i];
      if (!f.name.toString().endsWith('.pdf')) {
        this.alertService.notify('warn', 'Warn', 'Unsupported File,Only Pdf allowed. Please try again!');
        //event.target.parentElement.firstElementChild.innerText = ''
        event.target.value = null
        return;
      } else {
        event.target.parentElement.firstElementChild.innerText = f.name.toString();
      }
    }
  }

  returnRecord() {
    if (this.eccRecordForm.value.Comments == null || this.eccRecordForm.value.Comments == '') {
      this.showComment = true;
      this.alertService.notify('warn', 'Warn', 'Please fixed the validation errors in the form below  and try again!');
      return;
    }

    let bpAddressData: IBPAddress = this.eccRecordForm.value;

    this.eccRecordService.PostData('ReturnBPAddress/' + this.paramid, bpAddressData).subscribe((data) => {
      if (data == 1) {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record Return successfully');
        if (this.paramIsClient) {
          this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
        }
      }
    },
      error => {
        alert(error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )
  }

  approveRecord() {
    this.showComment = false;

    let bpAddressData: IBPAddress = this.eccRecordForm.value;

    this.eccRecordService.PostData('ApproveBPAddress/' + this.paramid, bpAddressData).subscribe((data) => {
      if (data == 1) {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record Approved successfully');
        if (this.paramIsClient) {
          this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
        }
      }
    },
      error => {
        alert(error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )
  }

  submitRecord() {
    let bpAddressData: IBPAddress = this.eccRecordForm.value;
    //set validation 
    this.showGSTNReasonError = false;
    this.showTanReasonError = false;
    this.showPanAttachError = false;
    this.showDecAttachError = false;
    this.showLoaAttachError = false;
    this.showGSTNAttachError = false;
    this.showGSTTypeError = false;

    this.showLoaDateToError = false;
    this.showLoaDateFromError = false;

    this.showGstnNoError = false;

    this.showTax1IdError = false;
    this.showTax1CountryError = false;
    this.showTax4IdError = false;
    this.showTax4CountryError = false;
    this.showTax3CountryError = false;
    this.showVatError = false;
    this.showVatCountryError = false;
    this.showNationalIdError = false;
    this.showNationalIdCountryError = false;
    this.showLoaValidationError = false;


    // set gst type 
    if (this.eccRecordForm.value.GSTINType && this.eccRecordForm.value.GSTINType.Id > 0) {
      bpAddressData.GSTINTypeId = this.eccRecordForm.value.GSTINType.Id;
      bpAddressData.GSTINTypeName = this.eccRecordForm.value.GSTINType.Name;
    } else {
      this.showGSTTypeError = true;
    }

    if ((bpAddressData.GSTINTypeId === 4 || bpAddressData.GSTINTypeId === 5) && (!bpAddressData.LoaValidityFrom || !bpAddressData.LoaValidityTo)) {
      this.showLoaValidationError = true;
    }

    if ((bpAddressData.GSTINTypeId === 4 || bpAddressData.GSTINTypeId === 5)) {
      if (bpAddressData.LoaValidityTo && new Date(bpAddressData.LoaValidityTo) < new Date()) {
        this.showLoaDateToError = true;
      }
      if (bpAddressData.LoaValidityFrom && bpAddressData.LoaValidityTo && new Date(bpAddressData.LoaValidityFrom) > new Date(bpAddressData.LoaValidityTo)) {
        this.showLoaDateFromError = true;
      }
    }


    if (!bpAddressData.Tax4Id && !bpAddressData.ReasonNonAvailabilityTAN) {
      this.showTanReasonError = true;
    }

    this.gstFile = document.getElementById("fileGst");
    const formDataGstFile = new FormData();
    if (this.gstFile.files.length > 0) {
      formDataGstFile.append(this.gstFile.files[0].name, this.gstFile.files[0]);
    }

    this.panFile = document.getElementById("filePan");
    const formDataPanFile = new FormData();
    if (this.panFile.files.length > 0) {
      formDataPanFile.append(this.panFile.files[0].name, this.panFile.files[0]);
    }

    this.declarationFile = document.getElementById("fileDeclaration");
    const formDataDeclarationFile = new FormData();
    if (this.declarationFile && this.declarationFile.files.length > 0) {
      formDataDeclarationFile.append(this.declarationFile.files[0].name, this.declarationFile.files[0]);
    }

    this.loaFile = document.getElementById("fileLoa");
    const formDataLoaFile = new FormData();
    if (this.loaFile && this.loaFile.files.length > 0) {
      formDataLoaFile.append(this.loaFile.files[0].name, this.loaFile.files[0]);
    }

    if ((bpAddressData.GSTINTypeId === 4 || bpAddressData.GSTINTypeId === 5) && (this.loaFile.files.length == 0 && !this.bpaddress.LoaAttachmentName)) {
      this.showLoaAttachError = true;
    }

    if (bpAddressData.GSTINTypeId === 6 && this.declarationFile.files.length == 0 && !this.bpaddress.DeclarationAttachmentName && bpAddressData.BPCountry && bpAddressData.BPCountry.toString().toUpperCase() == 'INDIA') {
      this.showDecAttachError = true;
    }
    if (bpAddressData.GSTINTypeId === 6 && bpAddressData.BPCountry && bpAddressData.BPCountry.toString().toUpperCase() == 'INDIA' && !bpAddressData.ReasonNonAvailabilityGSTIN) {
      this.showGSTNReasonError = true;
    }

    if (bpAddressData.BPCountry && bpAddressData.BPCountry.toString().toUpperCase() == 'INDIA' && bpAddressData.BPClassification != 'Individual'
      && (!bpAddressData.Tax4Id || bpAddressData.Tax4Id == '') && (bpAddressData.ReasonNonAvailabilityTAN == null || bpAddressData.ReasonNonAvailabilityTAN == '')) {
      this.showTax4IdError = true;
    }

    if (bpAddressData.BPCountry && bpAddressData.BPCountry.toString().toUpperCase() == 'INDIA' && bpAddressData.BPClassification != 'Individual'
      && (!bpAddressData.Tax4Country || bpAddressData.Tax4Country == '') && (bpAddressData.ReasonNonAvailabilityTAN == null || bpAddressData.ReasonNonAvailabilityTAN == '')) {
      this.showTax4CountryError = true;
    }


    if (!bpAddressData.NationalIdCountry || bpAddressData.NationalIdCountry == '') {
      this.showNationalIdCountryError = true;
    }
    // 22AAAAA0000A1Z5
    let GSTINNoPattern = '^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[a-zA-Z0-9]{3}';
    if (bpAddressData.GSTINTypeId != 6 && (!bpAddressData.Tax3Id || bpAddressData.Tax3Id == '')) {
      this.showGstnNoError = true;
    }

    if (bpAddressData.GSTINTypeId != 6 && (!bpAddressData.Tax3Country || bpAddressData.Tax3Country == '')) {
      this.showTax3CountryError = true;
    }

    if (bpAddressData.GSTINTypeId != 6 && this.gstFile.files.length == 0 && !this.bpaddress.GSTAttachmentName) {
      this.showGSTNAttachError = true;
    }

    if (bpAddressData.Tax3Id && !bpAddressData.Tax3Id.match(GSTINNoPattern)) {
      this.showGstnNoError = true;
    }

    if (this.showGSTNReasonError ||
      //|| this.showGstTanError || this.showPanReasonError ||
      // this.showTax1IdError || this.showTax1CountryError || this.showVatError || this.showVatCountryError || this.showNationalIdError || this.showNationalIdCountryError || this.showPanAttachError ||
      this.showTanReasonError || this.showGSTNAttachError || this.showGSTTypeError || this.showGstnNoError || this.showTax4IdError || this.showTax4CountryError || this.showTax3CountryError || this.showDecAttachError || this.showLoaAttachError || this.showLoaValidationError || this.showLoaDateToError || this.showLoaDateFromError) {

      this.alertService.notify('warn', 'Warning', 'Please fixed the validation errors in the form below and try again!');
      return;
    }

    let sources: any = [];

    if (this.gstFile && this.gstFile.files && this.gstFile.files.length > 0) {
      sources.push(this.eccRecordService.DownloadFileWithPost('UploadBPAddressGstFileBlob/' + this.paramid, formDataGstFile))
    }
    if (this.panFile && this.panFile.files && this.panFile.files.length > 0) {
      sources.push(this.eccRecordService.DownloadFileWithPost('UploadBPAddressPanFileBlob/' + this.paramid, formDataPanFile))
    }
    if (this.loaFile && this.loaFile.files && this.loaFile.files.length > 0) {
      sources.push(this.eccRecordService.DownloadFileWithPost('UploadBPAddressLoaFileBlob/' + this.paramid, formDataLoaFile))
    }
    if (this.declarationFile && this.declarationFile.files && this.declarationFile.files.length > 0) {
      sources.push(this.eccRecordService.DownloadFileWithPost('UploadBpAdressDeclarationFileBlob/' + this.paramid, formDataDeclarationFile))
    }

    sources.push(this.eccRecordService.PostData('UpdateBPAddress/' + this.paramid, bpAddressData))

    forkJoin(
      sources
    ).subscribe(
      (
        data
      ) => {

        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record updated successfully');

        let mdmid = this.eccRecordService.EncryptData(this.bpaddress.MdmId);

        if (this.paramAll) {
          if (this.paramIsClient) {
            this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isclient: true } });
          } else if (this.paramIsDpc) {
            this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isdpc: true } });
          } else {
            this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true } });
          }
        }
        else if (this.paramIsClient) {
          this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isdpc: true } });
        }

      },
      error => {
        this.alertService.notify('error', 'Error', error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }

    )

    /*forkJoin([
      this.eccRecordService.DownloadFileWithPost('UploadBPAddressGstFile/' + this.paramid, formDataGstFile),
      this.eccRecordService.DownloadFileWithPost('UploadBPAddressPanFile/' + this.paramid, formDataPanFile),
      this.eccRecordService.DownloadFileWithPost('UploadBPAddressLoaFile/' + this.paramid, formDataLoaFile),
      this.eccRecordService.DownloadFileWithPost('UploadBpAdressDeclarationFile/' + this.paramid, formDataDeclarationFile),
      this.eccRecordService.PostData('UpdateBPAddress/' + this.paramid, bpAddressData),
    ]).subscribe(
      ([
        data1,
        data2,
        data3,
        data4,
        data5,
      ]) => {
        if (data5 == 1) {
          this.progressService.ChangeProgressStatus(false);
          this.alertService.notify('success', 'Success', 'Record updated successfully');

          let mdmid = this.eccRecordService.EncryptData(this.bpaddress.MdmId);

          if (this.paramAll) {
            if (this.paramIsClient) {
              this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isclient: true } });
            } else if (this.paramIsDpc) {
              this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true, isdpc: true } });
            } else {
              this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isall: true } });
            }
          }
          else if (this.paramIsClient) {
            this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isclient: true } });
          } else if (this.paramIsDpc) {
            this.route.navigate(['/home/bprecorddetail'], { queryParams: { id: mdmid, isdpc: true } });
          }


          // if (this.paramIsClient) {
          //   this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
          // } else if (this.paramIsDpc) {
          //   this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
          // }
        }
      },
      error => {
        alert(error.statusText);
      }

    )*/
  }

  onGstnTypeChange(event) {
    event.value.Id == 4 || event.value.Id == 5 ? this.showLoa = true : this.showLoa = false
    event.value.Id == 6 ? this.showUnregistered = true : this.showUnregistered = false
  }

  displaySubmit() {
    let isDisplay = false;
    if (this.bpaddress.EccStatus == 3 && (!this.bpaddress.Tax3Id || !this.bpaddress.Tax3Country || !this.bpaddress.GSTAttachmentName || !this.bpaddress.DeclarationAttachmentName || !this.bpaddress.LoaAttachmentName || !this.bpaddress.Tax4Id || !this.bpaddress.Tax4Country)) {
      isDisplay = true;
    }
    else if (this.bpaddress.EccStatus == 1) {
      isDisplay = true;
    }
    return isDisplay
  }

  isDisabled(value: any) {
    let isDisabled = false;
    if (this.bpaddress && this.bpaddress.EccStatus == 2) {
      isDisabled = true;
    } else if (this.bpaddress && this.bpaddress.EccStatus == 1) {
      isDisabled = false;
    } else if (value && this.bpaddress.EccStatus == 3) {
      isDisabled = true;
    }
    return isDisabled;
  }

  isDpc() {
    let isDisabled = true;
    if (this.userHasRole(this.roles.DPC) && this.bpaddress && this.bpaddress.EccStatus === 2 && this.paramIsDpc) {
      isDisabled = false;
    }
    return isDisabled;
  }


}
